<script>
export default {
  name: 'ProjectDescription',
  props: {
    name: String,
    description: String,
    thumbnail: String,
    paddedThumb: Boolean,
  },
};
</script>

<template>
  <div class="project">
    <div v-if="paddedThumb">
      <div
        class="image-container image-container_padded"
      >
        <img :src="thumbnail" class="image">
      </div>
    </div>
    <div v-else :style="`background-image: url(${thumbnail})`" class="image-bg"></div>
    <div class="content">
      <div class="name">
        {{name}}
      </div>
    </div>
  </div>
</template>

<style scoped>
  .project {
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 290px;
    background: var(--main-bright);
  }

  .name {
    font-size: var(--font-size-m);
    font-weight: bold;
    padding: 12px 0;
  }

  .content {
  }

  .image {
    max-height: 100%;
  }

  .image-container {
    box-sizing: border-box;
    height: 150px;
    background-color: rgb(35, 37, 41);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .image-bg {
    height: 150px;
    width: 100%;
    background: no-repeat center center;
    background-size: cover;
  }

  .image-container_padded {
    padding: 20px;
  }
</style>
